import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { cssVar } from '../../hooks/useThemeStyles';

const ERROR_MESSAGES = {
  google_init_failed: 'Failed to start Google sign-in. Please try again.',
  google_denied: 'Google sign-in was cancelled.',
  google_callback_failed: 'Google sign-in failed. Please try again.',
  google_token_failed: 'Google sign-in failed (token exchange error). Please try again.',
  google_userinfo_failed: 'Google sign-in failed (could not fetch profile). Please try again.',
  google_db_failed: 'Google sign-in failed (account creation error). Please try again later.',
  server_misconfigured: 'Sign-in is temporarily unavailable. Please try again later.',
  missing_state: 'Sign-in session expired. Please try again.',
  invalid_state: 'Sign-in session expired. Please try again.',
  missing_code: 'Google sign-in was incomplete. Please try again.',
};

export default function AuthErrorToast() {
  const { error, clearError } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (error) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(clearError, 300); // clear after fade-out
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  if (!error) return null;

  const message = ERROR_MESSAGES[error] || `Sign-in error: ${error}`;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: cssVar.zToast,
        background: cssVar.error,
        color: '#fff',
        padding: '12px 40px 12px 16px',
        borderRadius: 8,
        fontSize: cssVar.textBase,
        fontFamily: cssVar.fontSans,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        maxWidth: 420,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease',
      }}
    >
      {message}
      <button
        onClick={() => { setVisible(false); clearError(); }}
        aria-label="Dismiss"
        style={{
          position: 'absolute',
          top: 8,
          right: 8,
          background: 'none',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          fontSize: 18,
          lineHeight: 1,
          padding: '2px 6px',
        }}
      >
        &times;
      </button>
    </div>
  );
}
